import { Injectable } from '@angular/core';
import { TRANSLATIONS } from '../constants/translations';

type ReplacementMap = Record<string, string | number>;

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private language: string | null = null;

  setLanguage(language: string): void {
    if (TRANSLATIONS[language]) {
      this.language = language;
    }
  }

  getLanguage(): string | null {
    return this.language;
  }

  translate(key: string, replacements: ReplacementMap = {}): string {
    const lang = this.language || 'ro';
    const dictionary = TRANSLATIONS[lang] ?? {};
    const template = dictionary[key] ?? key;

    return Object.entries(replacements).reduce((acc, [token, value]) => {
      const pattern = new RegExp(`\\{${token}\\}`, 'g');
      return acc.replace(pattern, String(value));
    }, template);
  }
}
